import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class WiFiAdHocTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "WiFi AdHoc Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Klienten-Liste aktualisieren', descriptionColumn: 'Klicken Sie auf , um die Liste der AdHoc-Klienten zu aktualisieren, die mit dem Access Point Ihrer Kamera verbunden sind.' },
        { actionColumn: 'SSID für den Access Point', descriptionColumn: 'Benennen Sie das WiFi-Netzwerk, das vom Access Point Ihrer Kamera erstellt wurde.' },
        { actionColumn: 'Verschlüsselungs Methode', descriptionColumn: 'Wählen Sie, ob das WiFi-Netzwerk WPA2-verschlüsselt oder unverschlüsselt sein soll.' },
        { actionColumn: 'WiFi Schlüssel für den Access Point', descriptionColumn: 'Fügen Sie ein Kennwort hinzu, das die Clients eingeben müssen, um sich mit dem Access Point Ihrer Kamera verbinden zu können.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

WiFiAdHocTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(WiFiAdHocTable)